// import React, { useEffect, useState } from "react";
// import {
//   disabledOnStatusValues,
//   masterCalculatedFieldsFn,
//   masterFormConfig,
//   masterSubmitApi,
//   parentIdColumnName,
//   statuses,
//   statusField,
//   transactionFormConfig,
// } from "./module";
// import Form from "../../../site/forms/master-transaction/form";

// const token = localStorage.getItem("zTaskAuthToken");

// function InvoiceForm({ rowId }) {
//   const [data, setData] = useState({
//     id: null,
//   });
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         if (rowId === undefined || Number.isNaN(parseInt(rowId))) return;
//         const response = await fetch(`${masterSubmitApi}/${rowId}`, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         if (response.ok) {
//           const result = await response.json();
//           setData(result);
//         } else {
//           console.error("API Error:", response.statusText);
//         }
//       } catch (error) {
//         console.error("Network or unexpected error:", error);
//       }
//     };

//     fetchData();
//   }, [rowId]);
//   return (
//     <Form
//       masterFormConfig={masterFormConfig}
//       transactionFormConfig={transactionFormConfig}
//       initialData={rowId ? { id: rowId, ...data } : data}
//       onFormSuccess={(invId) =>
//         console.log("Form saved successfully, Inv ID:", invId)
//       }
//       moduleName="Invoice"
//       submitTogether={true}
//       parentIdColumnName={parentIdColumnName}
//       masterCalculatedFieldsFn={masterCalculatedFieldsFn}
//       statusField={statusField}
//       disabledOnStatusValues={disabledOnStatusValues}
//       statuses={statuses}
//     />
//   );
// }

// export default InvoiceForm;






import React, { useEffect, useState } from "react";
import {
  disabledOnStatusValues,
  masterCalculatedFieldsFn,
  masterFormConfig,
  masterSubmitApi,
  parentIdColumnName,
  statuses,
  statusField,
  transactionFormConfig,
} from "./module";
import Form from "../../../site/forms/master-transaction/form";

const token = localStorage.getItem("zTaskAuthToken");

function InvoiceForm({ rowId }) {
  const [data, setData] = useState({
    id: null,
  });
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (rowId === undefined || Number.isNaN(parseInt(rowId))) return;
        const response = await fetch(`${masterSubmitApi}/${rowId}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const result = await response.json();
          setData(result);
        } else {
          console.error("API Error:", response.statusText);
        }
      } catch (error) {
        console.error("Network or unexpected error:", error);
      }
    };

    fetchData();
  }, [rowId]);
  return (
    <Form
      masterFormConfig={masterFormConfig}
      transactionFormConfig={transactionFormConfig}
      initialData={rowId ? { id: rowId, ...data } : data}
      onFormSuccess={(invId) =>
        console.log("Form saved successfully, Inv ID:", invId)
      }
      moduleName="Invoice"
      submitTogether={true}
      parentIdColumnName={parentIdColumnName}
      masterCalculatedFieldsFn={masterCalculatedFieldsFn}
      statusField={statusField}
      disabledOnStatusValues={disabledOnStatusValues}
      statuses={statuses}
    />
  );
}

export default InvoiceForm;
